/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import moment from 'moment';

const AuthorName = styled('div')`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: ${(props) => (props.isTvMode ? '30px' : '15px')};
  margin-bottom: 1px;
`;

const NameAndDate = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const PostDate = styled('div')`
  font-family: 'Nunito Sans', sans-serif;
  font-size: ${(props) => (props.isTvMode ? '16px' : '11px')};
  color: #999;
`;

const PostAuthorAndDate = ({ feedObject }) => {
  const isTvMode = useSelector((state) => state.feed.data.isTvMode);
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  const formatDateToLocalTime = (utcDateStr) => moment
    .utc(utcDateStr)
    .tz(currentUser.userTimeZone || currentUser.userSettings.timeZone)
    .format('MMMM D, YYYY h:mm A');

  return (
    <NameAndDate>
      <AuthorName isTvMode={isTvMode}>{feedObject.userName}</AuthorName>
      <PostDate isTvMode={isTvMode}>
        {formatDateToLocalTime(feedObject.createdAt)}
      </PostDate>
    </NameAndDate>
  );
};

export default PostAuthorAndDate;

PostAuthorAndDate.propTypes = {
  feedObject: PropTypes.instanceOf(Object).isRequired,
};
